var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "video_play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_line_style_24px",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "play_circle_FILL1_wght400_GRAD0_opsz20",
    d: "M8,13.5,13.5,10,8,6.5ZM10,18a7.8,7.8,0,0,1-3.1-.625A8.037,8.037,0,0,1,2.625,13.1,7.8,7.8,0,0,1,2,10a7.775,7.775,0,0,1,.625-3.115A8.066,8.066,0,0,1,6.9,2.625,7.8,7.8,0,0,1,10,2a7.775,7.775,0,0,1,3.115.625,8.1,8.1,0,0,1,4.26,4.26A7.775,7.775,0,0,1,18,10a7.8,7.8,0,0,1-.625,3.1,8.066,8.066,0,0,1-4.26,4.271A7.775,7.775,0,0,1,10,18Z",
    transform: "translate(1433 15)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video_play.a96e3c092645bd1aaa81ee03952611ba.svg";
export { ForwardRef as ReactComponent };